/**
 * Converte MIME type para extensão legível (ex: PDF, DOC, XLSX)
 * @param mimeType - MIME type do arquivo (ex: application/pdf)
 * @returns Extensão formatada (ex: PDF)
 */
export const getFileType = (mimeType?: string): string => {
  if (!mimeType) return 'ARQUIVO';

  const mimeMap: Record<string, string> = {
    'application/pdf': 'PDF',
    'application/msword': 'DOC',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      'DOCX',
    'application/vnd.ms-excel': 'XLS',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
    'application/vnd.ms-powerpoint': 'PPT',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      'PPTX',
    'application/vnd.oasis.opendocument.text': 'ODT',
    'application/vnd.oasis.opendocument.spreadsheet': 'ODS',
    'application/vnd.oasis.opendocument.presentation': 'ODP',
    'text/plain': 'TXT',
    'text/csv': 'CSV',
    'application/zip': 'ZIP',
    'application/x-rar-compressed': 'RAR',
    'application/x-7z-compressed': '7Z',
    'application/x-tar': 'TAR',
    'image/jpeg': 'JPG',
    'image/png': 'PNG',
    'image/gif': 'GIF',
    'image/webp': 'WEBP',
    'image/svg+xml': 'SVG',
    'audio/mpeg': 'MP3',
    'audio/wav': 'WAV',
    'video/mp4': 'MP4',
    'video/mpeg': 'MPEG',
    'video/quicktime': 'MOV',
    'video/x-msvideo': 'AVI',
    'video/x-ms-wmv': 'WMV',
  };

  return mimeMap[mimeType] || extractExtensionFromMime(mimeType);
};

/**
 * Extrai extensão do MIME type quando não há mapeamento direto
 * @param mimeType - MIME type do arquivo
 * @returns Extensão extraída em maiúsculas
 */
const extractExtensionFromMime = (mimeType: string): string => {
  const parts = mimeType.split('/');
  if (parts.length < 2) return 'ARQUIVO';

  const subtype = parts[1].split(';')[0]; // Remove charset ou outros parâmetros
  const ext = subtype.split('.').pop() || subtype;

  return ext.toUpperCase().slice(0, 10); // Limita a 10 caracteres
};

export default getFileType;
